import { BRAND } from "../risikoanalyseStep/tokens";
import type { ContractStepKind } from "./types";

const W = 140;
const H = 96;

const Wrap = ({ children }: { children: React.ReactNode }) => (
  <svg width={W} height={H} viewBox="0 0 140 96" fill="none">
    {children}
  </svg>
);

const Kontakt = () => (
  <Wrap>
    <circle cx="70" cy="40" r="18" fill={BRAND.purple} />
    <path d="M40 84c0-14 13-24 30-24s30 10 30 24" fill={BRAND.purple} />
    <circle cx="70" cy="40" r="18" fill="none" stroke={BRAND.gold} strokeWidth="2" />
  </Wrap>
);

const VertragsBasis = () => (
  <Wrap>
    <rect x="20" y="18" width="62" height="60" rx="4" fill={BRAND.bg} stroke={BRAND.purple} strokeWidth="2" />
    <path d="M28 32h46M28 42h36M28 52h40M28 62h26" stroke={BRAND.muted} strokeWidth="1.5" strokeLinecap="round" />
    <rect x="90" y="32" width="32" height="32" rx="4" fill={BRAND.gold} stroke={BRAND.ink} strokeWidth="1.5" />
    <path d="M98 48l6 6 12-14" stroke={BRAND.ink} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </Wrap>
);

const Risiko = () => (
  <Wrap>
    <path d="M70 14l32 12v22c0 18-14 32-32 38-18-6-32-20-32-38V26l32-12z" fill={BRAND.pillarOrange} />
    <text x="70" y="58" fontFamily="Arial" fontSize="20" textAnchor="middle" fill={BRAND.white} fontWeight="700">!</text>
  </Wrap>
);

const Summen = () => (
  <Wrap>
    <rect x="14" y="28" width="112" height="44" rx="4" fill={BRAND.bg} stroke={BRAND.purple} strokeWidth="2" />
    <text x="42" y="58" fontFamily="Arial" fontSize="22" textAnchor="middle" fill={BRAND.purple} fontWeight="700">€</text>
    <path d="M70 38v24M62 50h16" stroke={BRAND.gold} strokeWidth="3" strokeLinecap="round" />
    <text x="106" y="58" fontFamily="Arial" fontSize="14" textAnchor="middle" fill={BRAND.ink} fontWeight="700">100%</text>
  </Wrap>
);

const Umfang = () => (
  <Wrap>
    <path d="M70 14l32 12v22c0 18-14 32-32 38-18-6-32-20-32-38V26l32-12z" fill={BRAND.pillarGreen} />
    <text x="70" y="58" fontFamily="Arial" fontSize="16" textAnchor="middle" fill={BRAND.white} fontWeight="700">SB</text>
  </Wrap>
);

const Zahlung = () => (
  <Wrap>
    <rect x="14" y="32" width="84" height="40" rx="4" fill={BRAND.bg} stroke={BRAND.purple} strokeWidth="2" />
    <rect x="14" y="38" width="84" height="8" fill={BRAND.purple} />
    <circle cx="32" cy="58" r="4" fill={BRAND.gold} />
    <circle cx="50" cy="58" r="4" fill={BRAND.gold} />
    <circle cx="68" cy="58" r="4" fill={BRAND.gold} />
    <circle cx="86" cy="58" r="4" fill={BRAND.gold} />
    <circle cx="116" cy="48" r="14" fill={BRAND.gold} />
    <text x="116" y="54" fontFamily="Arial" fontSize="14" textAnchor="middle" fill={BRAND.ink} fontWeight="700">€</text>
  </Wrap>
);

const Summary = () => (
  <Wrap>
    <rect x="20" y="14" width="80" height="68" rx="4" fill={BRAND.bg} stroke={BRAND.purple} strokeWidth="2" />
    <path d="M28 26h64M28 38h64M28 50h64M28 62h44" stroke={BRAND.muted} strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="110" cy="74" r="14" fill={BRAND.pillarGreen} />
    <path d="M104 74l4 4 8-8" stroke={BRAND.white} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </Wrap>
);

const StepHero = ({ kind }: { kind: ContractStepKind }) => {
  switch (kind) {
    case "kontakt":
      return <Kontakt />;
    case "vertragsBasis":
      return <VertragsBasis />;
    case "risikoinformation":
      return <Risiko />;
    case "summen":
      return <Summen />;
    case "umfang":
      return <Umfang />;
    case "zahlung":
      return <Zahlung />;
    case "summary":
      return <Summary />;
    default:
      return <VertragsBasis />;
  }
};

export default StepHero;
